import { toast } from 'react-toastify';
import firebase from '../firebase';
import { GET_FEEDBACKS } from './types';
import { v4 as uuidv4 } from 'uuid';
import { customAlert } from './alertActions';
export const setFeedbackLoading = val => {
	return async dispatch => {
		dispatch({
			type: 'FEEDBACK_LOADING',
			payload: val,
		});
	};
};

export const getFeedbacks = uid => {
	return dispatch => {
		firebase
			.firestore()
			.collection('feedback')
			.where('user_id', '==', uid)
			.onSnapshot(query => {
				var tempFeedbacks = [];
				query.forEach(doc => {
					tempFeedbacks.push({ id: doc.id, ...doc.data() });
				});
				dispatch({
					type: GET_FEEDBACKS,
					feedbacks: tempFeedbacks,
				});
			});
	};
};
export const createFeedback = obj => async dispatch => {
	dispatch(setFeedbackLoading(true));
	firebase
		.firestore()
		.collection('feedback')
		.add({
			...obj,
			created_at: firebase.firestore.Timestamp.now(),
		})
		.then(res => {
			dispatch(customAlert(true, 'Feedback Recorded Successfully'));
			setTimeout(() => {
				dispatch(customAlert(false, ''));
			}, 3000);
			// toast.success('Feedback Recorded Successfully');
			dispatch(setFeedbackLoading(false));
			return;
		})
		.catch(err => {
			dispatch(customAlert(true, err.message));
			setTimeout(() => {
				dispatch(customAlert(false, ''));
			}, 3000);
			// toast.warning(err.message);
			dispatch(setFeedbackLoading(false));
		});
};
export const getFaqs = () => {
	return dispatch => {
		firebase
			.firestore()
			.collection('faqs')
			.orderBy('name')
			.onSnapshot(query => {
				var temp = [];
				query.forEach(doc => {
					temp.push({ id: doc.id, ...doc.data() });
				});
				dispatch({
					type: 'GET_FAQS',
					payload: temp,
				});
			});
	};
};

export const createRequest = (obj, file) => async dispatch => {
	dispatch(setFeedbackLoading(true));
	if (file) {
		try {
			let filename = file.name;
			let ext2 = filename.slice(filename.lastIndexOf('.'));
			let file_name = uuidv4() + ext2.toLowerCase();
			let storageRef = await firebase
				.storage()
				.ref('requests_images/' + file_name)
				.put(file);
			let url = await storageRef.ref.getDownloadURL();
			firebase
				.firestore()
				.collection('customer_requests')
				.add({
					...obj,
					created_at: firebase.firestore.Timestamp.now(),
					requested_file: url,
				})
				.then(res => {
					dispatch(
						customAlert(true, 'Your request submitted successfully')
					);
					setTimeout(() => {
						dispatch(customAlert(false, ''));
					}, 3000);
					// toast.success('Your request submitted successfully');
					dispatch(setFeedbackLoading(false));
					return;
				})
				.catch(err => {
					dispatch(customAlert(true, err.message));
					setTimeout(() => {
						dispatch(customAlert(false, ''));
					}, 3000);
					// toast.warning(err.message);
					dispatch(setFeedbackLoading(false));
				});
		} catch (e) {
			console.log('error', e.message);
			dispatch(customAlert(true, e.message));
			setTimeout(() => {
				dispatch(customAlert(false, ''));
			}, 3000);
			// toast.warning(e.message);
			dispatch(setFeedbackLoading(false));
		}
	} else {
		firebase
			.firestore()
			.collection('customer_requests')
			.add({
				...obj,
				created_at: firebase.firestore.Timestamp.now(),
			})
			.then(res => {
				dispatch(
					customAlert(true, 'Your request submitted successfully')
				);
				setTimeout(() => {
					dispatch(customAlert(false, ''));
				}, 3000);
				// toast.success('Your request submitted successfully');
				dispatch(setFeedbackLoading(false));
				return;
			})
			.catch(err => {
				dispatch(customAlert(true, err.message));
				setTimeout(() => {
					dispatch(customAlert(false, ''));
				}, 3000);
				// toast.warning(err.message);
				dispatch(setFeedbackLoading(false));
			});
	}
};
